import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../../data/followup/constants/history_actions';
import * as Entries from '../../components/history/Entries';
import {UPDATE_CANCELLED_BY_CUSTOMER} from "../../../../data/followup/constants/history_actions";
import {QuotationUpdateCancelled} from "../../components/history/Entries";

class EntryContainer extends Component {
    static propTypes = {
        isFirst: PropTypes.bool,
        isLast: PropTypes.bool,
        type: PropTypes.string,
        meta: PropTypes.object,
        data: PropTypes.object
    };

    render() {
        const { type } = this.props;

        switch(type) {
            case types.QUOTATION_CREATION:
                return <Entries.QuotationCreation {...this.props} />;
            case types.QUOTATION_REQUEST:
                return <Entries.QuotationRequest {...this.props} />;
            case types.CUSTOMER_MESSAGE:
                return <Entries.CustomerMessage {...this.props} />;
            case types.USER_MESSAGE:
                return <Entries.UserMessage {...this.props} />;
            case types.WIP:
                return <Entries.Wip {...this.props} />;
            case types.QUOTATION_SUBMIT:
                return <Entries.QuotationSubmit {...this.props} />;
            case types.QUOTATION_CANCELLATION:
                return <Entries.QuotationCancellation {...this.props} />;
            case types.QUOTATION_REJECT:
                return <Entries.QuotationReject {...this.props} />;
            case types.QUOTATION_ARCHIVING:
                return <Entries.QuotationArchiving {...this.props} />;
            case types.QUOTATION_ACCEPTATION:
                return <Entries.QuotationAcceptation {...this.props} />;
            case types.QUOTATION_UPDATED:
                return <Entries.QuotationUpdated {...this.props} />;
            case types.UPDATE_CANCELLED_BY_CUSTOMER:
                return <Entries.QuotationUpdateCancelled {...this.props} />;
            case types.RESERVATION_CREATION:
                return <Entries.ReservationCreation {...this.props} />;
            case types.RESERVATION_CHANGE:
                return <Entries.ReservationChange {...this.props} />;
            case types.RESERVATION_ADD_PAYMENT:
                return <Entries.ReservationAddPayment {...this.props} />;
            case types.RESERVATION_ADD_REFUND:
                return <Entries.ReservationAddRefund {...this.props} />;
            case types.RESERVATION_TERMINATE:
                return <Entries.ReservationTerminate {...this.props} />;
            case types.RESERVATION_CANCEL:
                return <Entries.ReservationCancel {...this.props} />;
        }

        return null;
    }
}

export default EntryContainer;
